import { InvoiceItemSetting } from "./procedure-detail";
import { PaymentConst } from "../payment/const";

export class InvoiceItemValidator {
  constructor(readonly item: InvoiceItemSetting) {}

  isValid() {
    return Object.values(this.validate()).every((k) => k === undefined);
  }

  validate(): {
    description?: string;
    formulaId?: string;
  } {
    const error: {
      description?: string;
      formulaId?: string;
    } = {};
    error.formulaId = this.formulaId;
    error.description = this.description;
    return error;
  }

  private get formulaId(): string | undefined {
    if (!this.item.formulaId) {
      return "金額計算を行う数式を選択してください";
    }
    return undefined;
  }

  private get description(): string | undefined {
    if (!this.item.description) {
      return "費目を入力してください。";
    }
    if (this.item.description.length > PaymentConst.MAX_DESCRIPTION_LENGTH) {
      return `費目は${PaymentConst.MAX_DESCRIPTION_LENGTH}文字まで入力できます`;
    }
    return undefined;
  }
}
